<template>
    <div class="lc_dropdown"
         :class="{'select' : styleSelect}"
         @click.stop="m_onClickDropdown_f()">

        <!-- selected -->
        <div class="lc_dropDown_select" :class="{'tq_dropDown_showCaret' : showCaretDown}">
            <div class="tq_dropDown_value" ref="ref_tqDropDown_select">
                <slot name="select"></slot>
            </div>

            <img v-if="showCaretDown" :src="ass_img_caretDown_b" class="img_caretDown TQ_width_12px "/>
        </div>

        <!-- dropdown -->
        <div v-show="p_show_vb.val"
             class="lc_optionsWrapper_first TQ_animation_show "
             v-click-out-side="() => { p_show_vb.val = false}"
             :style="{'zIndex': gv_zIndex.tqDropDown_options_mobile}" >

            <!-- dropdown laptop -->
            <div v-if="co_desktopMode_b"
                 id="optionsWrapper"
                 class="optionsWrapper_second laptop TQ_borderBox TQ_clickable "
                 :style="{'width' : optionsWidth, 'maxHeight' : maxHeight, 'marginBottom': showUpward || p_onlyUpward_b ? selectHeight_n + 'px' : '0px'}"
                 :class="{'lc_upward': showUpward || p_onlyUpward_b, 'overflowVisible' : p_overflowVisible_b}"
                 @click="m_onClickOptions_f()">

                <!-- search input -->
                <input class="TQ_width_100p TQ_center TQ_padding_4px TQ_text_20px TQ_borderBox TQ_bg_purple_lite TQ_textColor_white"
                       autocomplete="off"
                       v-if="pe_updateSearch_f && p_showSearchBar_b"
                       v-model="searchInput_s"
                       @input="() => {pe_updateSearch_f(searchInput_s)}"
                       @click.stop="() => {}"
                       :placeholder="ass_strings.oneWord_search[p_systemLangCode_e]"/>
                <slot name="options"></slot>
            </div>

            <!-- dropdown mobile -->
            <div  v-else
                  class="lc_optionsWrapperGrayBackground  ">
                <div class="optionsWrapper_second mobile TQ_borderRadius"
                     :style="{'width' : optionsWidth, 'maxHeight' : maxHeight, 'maxWidth' :maxWidth }"
                     @click="m_onClickOptions_f()">

                    <!-- search input -->
                    <input class="TQ_width_100p TQ_center TQ_padding_4px TQ_text_20px TQ_borderBox TQ_bg_purple_lite TQ_textColor_white"
                           autocomplete="off"
                           v-if="pe_updateSearch_f && p_showSearchBar_b"
                           v-model="searchInput_s"
                           @input="() => {pe_updateSearch_f(searchInput_s)}"
                           @click.stop="() => {}"
                           :placeholder="ass_strings.oneWord_search[p_systemLangCode_e]"/>

                    <slot name="options"></slot>
                </div>
            </div>

        </div>

    </div>

</template>

<script>

    import {store_var, store_getStateValue_vo} from "../../store";
    import {enum_dropdownMode, enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum";
    import {validator_pointerTypeOf_fb, validator_null_fb, validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {date_setTimeout} from "../../scripts/S_Date";
    import {
        ass_img_caretDown_b,
        ass_img_searchEmpty_w
    } from "../../assets/scripts/Ass_Files";
    import {gv_zIndex} from "../../scripts/S_GlobalVar";
    import {enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";

    export default {
        name: "TqDropdown",
        props:{

            p_show_vb:{
                type: Object,
                default() {
                    return {val : false}
                },
                validator(p){
                    return validator_pointerTypeOf_fb(p, 'boolean')
                }
            },

            optionsSelectable:{
                type: Boolean,
                default: true
            },
            onlyLaptopMode:{
                type: Boolean,
                default: false
            },
            ps_onlyMobileMode_b:{
                type: Boolean,
                default: false
            },
            p_onlyUpward_b:{
                type: Boolean,
                default: false
            },
            showCaretDown:{
                type: Boolean,
                default: true
            },
            optionsMaxWidth:{
                type: String,
                default: '250px'
            },
            optionsWidth:{
                type: String,
                default: '100%'
            },
            maxWidth:{
                type: String,
                default: '250px'
            },
            maxHeight:{
                type: String,
                default: '250px'
            },
            styleSelect:{
                type : Boolean
            },
            p_overflowVisible_b : {
                type: Boolean,
                default: false
            },

            p_showSearchBar_b:{
                type: Boolean,
                default : false
            },
            p_systemLangCode_e:{
                type: String,
                validator(val){
                    return validator_null_fb(val) || validator_enum_fb(enum_langCodes, val)
                }
            },
            pe_updateSearch_f : {
                type: Function,
            },


        },
        data(){
            return {
                showUpward              : false,
                clickedOptions          : false,
                lastAddedToBodyElement  : null,
                searchInput_s           : "",

                // store
                windowSizeType_s        : store_getStateValue_vo(store_var.system_windowSizeType_e),

                // imports
                enum_windowSizeType_l   : enum_screenSizesOptions_n,
                enum_dropdownMode_i     : enum_dropdownMode,
                ass_img_caretDown_b     : ass_img_caretDown_b,
                gv_zIndex               : gv_zIndex,
                ass_img_searchEmpty_w   : ass_img_searchEmpty_w,
                ass_strings   : ass_strings,

                selectHeight_n          : 0

            }
        },
        computed : {
            co_desktopMode_b(){
                return (this.windowSizeType_s.val === this.enum_windowSizeType_l.laptop || this.onlyLaptopMode) && !this.ps_onlyMobileMode_b
            }
        },
        methods:{

            m_onClickOptions_f(){
                this.clickedOptions = true
            },
            m_onClickDropdown_f(){

                // dont close window
                if( !this.optionsSelectable
                    && this.p_show_vb.val
                    && this.clickedOptions){
                    this.clickedOptions = false
                    return
                }

                // close window
                if(this.p_show_vb.val){
                    this.p_show_vb.val = false
                }else{
                    this.p_show_vb.val = true
                    this.m_updateDisplayUpwardIfNeeded_f()
                }


            },
            m_updateDisplayUpwardIfNeeded_f(){
                this.showUpward = false;


                date_setTimeout(() => {

                    let node = document.getElementById("optionsWrapper")
                    if(node){

                        let scrollTop   = this.m_updateDisplayUpwardIfNeeded_getScrollParent_f(node)
                        let nodePos     = this.m_updateDisplayUpwardIfNeeded_findPos_f(node)
                        let windowBottomSpace = window.innerHeight - (nodePos - scrollTop)

                        let nodeHeight = document.getElementById("optionsWrapper").offsetHeight

                        this.showUpward = nodeHeight > windowBottomSpace
                    }
                }, 1, this.$options.name);


            },
            m_updateDisplayUpwardIfNeeded_findPos_f(node) {
                let curtop = 0;
                let curtopscroll = 0;
                if (node.offsetParent) {
                    do {
                        curtop += node.offsetTop;
                        curtopscroll += node.offsetParent ? node.offsetParent.scrollTop : 0;
                    } while (node = node.offsetParent);

                    return (curtop - curtopscroll);
                }
            },
            m_updateDisplayUpwardIfNeeded_getScrollParent_f(node) {

                while(node != null && node.scrollTop === 0){
                    node = node.parentNode
                }

                if(node == null || node.scrollTop == null){
                    return 0
                }else{
                    return node.scrollTop
                }

            }
        },

        mounted(){
            this.selectHeight_n = this.$refs.ref_tqDropDown_select.offsetHeight
        }

    }

</script>

<style scoped lang="scss">

    .lc_dropdown{
        display: inline-block;

        // select
        .lc_dropDown_select{
            cursor: pointer;
            &.tq_dropDown_showCaret{
                display: grid;
                /*grid-template-columns:auto 1fr auto;*/
                grid-template-columns:1fr auto;
                grid-template-rows: auto;
            }

            .space{
                width: 20px;
            }

            .tq_dropDown_value{
                align-self: center;
            }

            .img_caretDown{
                align-self: center;
                margin: 4px;
            }
        }


        .lc_optionsWrapper_first {
            position: relative;



            /* optionsWrapper*/
            .optionsWrapper_second{
                position: relative;
                box-shadow: 4px 8px 4px 0px rgba(0,0,0,0.4);

                &.overflowVisible{
                    overflow: visible !important; // ios stop cutting popup position:fixed
                }

                &.laptop{
                    position: absolute;
                    background: white;
                    overflow-y: auto;

                    &.lc_upward{
                        bottom: 100%;
                    }
                }

                &.mobile{
                    overflow-y: auto;
                    position: fixed;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    background: white;
                }

            }

            .lc_optionsWrapperGrayBackground {
                background-color: rgba(0, 0, 0, .5);
                position: fixed;
                top: 0;
                right: 0;
                height: 100vh;
                width: 100vw;
                overflow: visible;
            }
        }

    }


    /* select style */
    .lc_dropdown.select{

        .lc_dropDown_select{

            border: 1px solid black;
            padding: 4px;
            min-height: 20px;
        }

        .optionsWrapper_second{
            > div {
                border-bottom: 1px solid black;
                padding: 8px 0px
            }
        }
    }


    ::-webkit-input-placeholder { /* Edge */
        color: white;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: white;
    }

    ::placeholder {
        color: white;
    }



</style>